export * from './text-area-emoji.component';